export const DEFAULT_COUNTRY_CODE = 'CA';

const canadianRegions = [
    ['AB', 'Alberta'],
    ['BC', 'British Columbia'],
    ['MB', 'Manitoba'],
    ['NB', 'New Brunswick'],
    ['NL', 'Newfoundland and Labrador'],
    ['NS', 'Nova Scotia'],
    ['NU', 'Nunavut'],
    ['NT', 'Northwest Territories'],
    ['ON', 'Ontario'],
    ['PE', 'Prince Edward Island'],
    ['QC', 'Quebec'],
    ['SK', 'Saskatchewan'],
    ['YT', 'Yukon'],
];

const unitedStatesRegions = [
    ['AL', 'Alabama'],
    ['AK', 'Alaska'],
    ['AZ', 'Arizona'],
    ['AR', 'Arkansas'],
    ['CA', 'California'],
    ['CO', 'Colorado'],
    ['CT', 'Connecticut'],
    ['DE', 'Delaware'],
    ['DC', 'District Of Columbia'],
    ['FL', 'Florida'],
    ['GA', 'Georgia'],
    ['HI', 'Hawaii'],
    ['ID', 'Idaho'],
    ['IL', 'Illinois'],
    ['IN', 'Indiana'],
    ['IA', 'Iowa'],
    ['KS', 'Kansas'],
    ['KY', 'Kentucky'],
    ['LA', 'Louisiana'],
    ['ME', 'Maine'],
    ['MD', 'Maryland'],
    ['MA', 'Massachusetts'],
    ['MI', 'Michigan'],
    ['MN', 'Minnesota'],
    ['MS', 'Mississippi'],
    ['MO', 'Missouri'],
    ['MT', 'Montana'],
    ['NE', 'Nebraska'],
    ['NV', 'Nevada'],
    ['NH', 'New Hampshire'],
    ['NJ', 'New Jersey'],
    ['NM', 'New Mexico'],
    ['NY', 'New York'],
    ['NC', 'North Carolina'],
    ['ND', 'North Dakota'],
    ['OH', 'Ohio'],
    ['OK', 'Oklahoma'],
    ['OR', 'Oregon'],
    ['PA', 'Pennsylvania'],
    ['RI', 'Rhode Island'],
    ['SC', 'South Carolina'],
    ['SD', 'South Dakota'],
    ['TN', 'Tennessee'],
    ['TX', 'Texas'],
    ['UT', 'Utah'],
    ['VT', 'Vermont'],
    ['VA', 'Virginia'],
    ['WA', 'Washington'],
    ['WV', 'West Virginia'],
    ['WI', 'Wisconsin'],
    ['WY', 'Wyoming'],
    ['PR', 'Puerto Rico'],
    ['VI', 'Virgin Islands'],
    ['MP', 'Northern Mariana Islands'],
    ['GU', 'Guam'],
    ['AS', 'American Samoa'],
    ['PW', 'Palau'],
];

const alphanumericPostalCode = (value, maxLength) =>
    value
        .replace(/[^0-9a-zA-Z]/g, '')
        .slice(0, maxLength)
        .toUpperCase();

const numericPostalCode = (value, maxLength) => value.replace(/\D/g, '').slice(0, maxLength);

export const countryProfiles = [
    {
        code: 'CA',
        aliases: ['CANADA'],
        label: 'Canada',
        phone: { minLength: 10, maxLength: 11 },
        postalCode: {
            label: 'Postal Code',
            normalize: (value) => alphanumericPostalCode(value, 6),
            isValid: (value) => /^[A-Z]\d[A-Z]\d[A-Z]\d$/i.test(value),
        },
        region: { mode: 'select', label: 'Province', options: canadianRegions },
    },
    {
        code: 'US',
        aliases: ['UNITED STATES'],
        label: 'United States',
        phone: { minLength: 10, maxLength: 11 },
        postalCode: {
            label: 'ZIP',
            normalize: (value) => numericPostalCode(value, 9),
            isValid: (value) => /^\d{5}(\d{4})?$/.test(value),
        },
        region: { mode: 'select', label: 'State', options: unitedStatesRegions },
    },
    {
        code: 'GB',
        aliases: ['UNITED KINGDOM'],
        label: 'United Kingdom',
        phone: { minLength: 10, maxLength: 12 },
        postalCode: {
            label: 'Postcode',
            normalize: (value) => alphanumericPostalCode(value, 8),
            isValid: (value) => value.length >= 6 && value.length <= 8,
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'AU',
        aliases: ['AUSTRALIA'],
        label: 'Australia',
        phone: { minLength: 10, maxLength: 11 },
        postalCode: {
            label: 'Postcode',
            normalize: (value) => alphanumericPostalCode(value, 4),
            isValid: (value) => value.length === 4,
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'NL',
        aliases: ['NETHERLANDS'],
        label: 'Netherlands',
        phone: { minLength: 10, maxLength: 11 },
        postalCode: {
            label: 'Postcode',
            normalize: (value) => alphanumericPostalCode(value, 6),
            isValid: (value) => value.length === 6,
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'ES',
        aliases: ['SPAIN'],
        label: 'Spain',
        phone: { minLength: 9, maxLength: 11 },
        postalCode: {
            label: 'Postal Code',
            normalize: (value) => numericPostalCode(value, 5),
            isValid: (value) => /^\d{5}$/.test(value),
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'BE',
        aliases: ['BELGIUM'],
        label: 'Belgium',
        phone: { minLength: 9, maxLength: 11 },
        postalCode: {
            label: 'Postal Code',
            normalize: (value) => numericPostalCode(value, 4),
            isValid: (value) => /^\d{4}$/.test(value),
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'CH',
        aliases: ['SWITZERLAND'],
        label: 'Switzerland',
        phone: { minLength: 9, maxLength: 11 },
        postalCode: {
            label: 'Postal Code',
            normalize: (value) => numericPostalCode(value, 4),
            isValid: (value) => /^\d{4}$/.test(value),
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'DE',
        aliases: ['GERMANY'],
        label: 'Germany',
        phone: { minLength: 6, maxLength: 13 },
        postalCode: {
            label: 'Postal Code',
            normalize: (value) => numericPostalCode(value, 5),
            isValid: (value) => /^\d{5}$/.test(value),
        },
        region: { mode: 'hidden' },
    },
    {
        code: 'FR',
        aliases: ['FRANCE'],
        label: 'France',
        phone: { minLength: 10, maxLength: 11 },
        postalCode: {
            label: 'Postal Code',
            normalize: (value) => numericPostalCode(value, 5),
            isValid: (value) => /^\d{5}$/.test(value),
        },
        region: { mode: 'hidden' },
    },
];

const profilesByCode = countryProfiles.reduce((profiles, profile) => {
    profiles[profile.code] = profile;
    return profiles;
}, {});

export function getCountryProfile(countryCode) {
    return profilesByCode[countryCode] || profilesByCode[DEFAULT_COUNTRY_CODE];
}

export function normalizeCountryCode(country) {
    if (typeof country !== 'string') return DEFAULT_COUNTRY_CODE;

    const normalized = country.trim().toUpperCase();
    const profile = countryProfiles.find(
        (candidate) => candidate.code === normalized || candidate.aliases.includes(normalized),
    );

    return profile ? profile.code : DEFAULT_COUNTRY_CODE;
}

export function normalizePostalCode(postalCode, countryCode) {
    return getCountryProfile(countryCode).postalCode.normalize(postalCode);
}

export function isValidPostalCode(postalCode, countryCode) {
    return getCountryProfile(countryCode).postalCode.isValid(postalCode);
}

export function normalizePhone(phone, countryCode) {
    return phone.replace(/\D/g, '').slice(0, getCountryProfile(countryCode).phone.maxLength);
}

export function isValidPhone(phone, countryCode) {
    const { minLength, maxLength } = getCountryProfile(countryCode).phone;
    return phone.length >= minLength && phone.length <= maxLength;
}
